/**
 * Профиль игрока GET /me.
 */

import { apiFetch } from "./client.js";

export type PlayerProfile = {
  readonly id: string;
  readonly nickname: string;
  readonly level: number;
  readonly xp: number;
  readonly hearthHex: string | null;
  readonly hearthTz: string | null;
  readonly locale: string;
  readonly shieldUntil: string | null;
  readonly emailVerified: boolean;
  /** Сколько сот держит игрок. Нужно подсказке первых шагов (§24.3). */
  readonly ownedHexes?: number;
};

export async function fetchProfile(
  token: string,
  signal?: AbortSignal,
): Promise<PlayerProfile> {
  return apiFetch<PlayerProfile>("/me", { token, ...(signal ? { signal } : {}) });
}
